<div class="chat-response chat-response-answer" [innerHTML]="renderMarkdown(response.data)"></div>
